import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "className"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import { createWrapContext } from '../tools/context';
import ConfigConsumerProvider from '../ConfigConsumerProvider'; // ButtonGroup嵌套context，如果ButtonGroup嵌套了其他ButtonGroup，则只有一个外层容器

var ButtonGroupWrapContext = createWrapContext(false);

function ButtonGroupWrapper(_ref) {
  var children = _ref.children,
      className = _ref.className,
      others = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({}, others, {
    className: classNames('jmtd-button-group', className)
  }), children);
}

ButtonGroupWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
ButtonGroupWrapper.defaultProps = {
  children: null,
  className: ''
};
export default function ButtonGroup(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      size = _ref2.size,
      block = _ref2.block,
      dataComponentName = _ref2['data-component-name'];
  return /*#__PURE__*/React.createElement(ConfigConsumerProvider, {
    size: size
  }, /*#__PURE__*/React.createElement(ButtonGroupWrapContext.Provider, {
    "data-component-name": dataComponentName,
    wrapper: ButtonGroupWrapper,
    className: classNames(className, {
      'jmtd-button-group-block': block
    })
  }, children));
}
ButtonGroup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.oneOf(['large', 'middle', 'small', 'mini']),
  block: PropTypes.bool,
  'data-component-name': PropTypes.string
};
ButtonGroup.defaultProps = {
  children: null,
  className: '',
  size: null,
  block: false,
  'data-component-name': ''
};